import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//DevExpress
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel'
import { LoadingPanelComponent } from './components/loading-panel.component';
//Base

//Loading

@NgModule({
    declarations: [
        LoadingPanelComponent
    ],
    imports: [
        CommonModule,
        DxLoadPanelModule
    ],
    exports: [LoadingPanelComponent],
    providers: []
})

export class LoadingModule {
}